/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as s from "react";
import e from "prop-types";
import { classNames as c } from "@progress/kendo-react-common";
const l = "ActionSheetFooter", n = (a) => {
  const {
    actionButtonsAlignment: o = "stretched",
    actionButtonsOrientation: t = "horizontal",
    className: i,
    children: r
  } = a;
  return /* @__PURE__ */ s.createElement(
    "div",
    {
      className: c(
        "k-actionsheet-footer",
        {
          "k-actions": o || t,
          "k-actions-horizontal": t === "horizontal",
          "k-actions-vertical": t === "vertical",
          "k-actions-start": o === "start" && t === "horizontal",
          "k-actions-center": o === "center" && t === "horizontal",
          "k-actions-end": o === "end" && t === "horizontal",
          "k-actions-stretched": o === "stretched",
          "k-actions-justify": o === "justify" && t === "horizontal"
        },
        i
      )
    },
    r
  );
};
n.propTypes = {
  className: e.string,
  children: e.any,
  actionButtonsOrientation: e.oneOf(["horizontal", "vertical"]),
  actionButtonsAlignment: e.oneOf(["start", "center", "end", "stretched", "justify"])
};
n.displayName = l;
export {
  n as ActionSheetFooter,
  l as footerDisplayName
};
